import { render, staticRenderFns } from "./ComplaintView.vue?vue&type=template&id=16c3b03b&scoped=true&"
import script from "./ComplaintView.vue?vue&type=script&lang=js&"
export * from "./ComplaintView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c3b03b",
  null
  
)

export default component.exports